import React from "react";
import {Fade, CircularProgress, styled} from "@mui/material";

const Overlay = styled('div')({
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(255, 255, 255, 0.5)',
});

const LoadingOverlay = props => {
    const {isLoading, transparent, size, children} = props;

    let circularSize = 40;
    let circularThickness = 3.6;

    if (size === 'large') {
        circularSize = 80;
        circularThickness = 3.8;
    }

    if (isLoading) {
        return (
            <Overlay style={transparent && {backgroundColor: 'transparent'}}>
                <Fade
                    in={isLoading}
                    style={{transitionDelay: isLoading ? '300ms' : '0ms',}}
                    unmountOnExit>
                    <CircularProgress
                        color="primary"
                        size={circularSize}
                        thickness={circularThickness}
                    />
                </Fade>
            </Overlay>
        )
    } else {
        return <>{children}</>;
    }
};

export {LoadingOverlay}